import { sectionIds } from '@/common/components/FilterViews/constants'

export const filterNames = {
  query: 'query',
  pageSize: 'pageSize',
  cursor: 'cursor',
  missing: 'missing',
  country: 'country',
  weightLte: 'weightLte',
  weightGte: 'weightGte',
  unitCostGte: 'unitCostGte',
  unitCostLte: 'unitCostLte',
  category: 'category',
  productStatus: 'productStatus',
  hasExportPrice: 'hasExportPrice',
  exportPriceCountry: 'exportPriceCountry',
}

export const filters = [
  { name: filterNames.query, type: 'string', backendName: 'search' },
  { name: filterNames.pageSize, type: 'number', backendName: 'page_size', defaultValue: 25 },
  { name: filterNames.cursor, type: 'string', backendName: 'cursor' },
  { name: filterNames.missing, type: 'string' },
  { name: filterNames.country, type: 'string', backendName: 'country_code' },
  { name: filterNames.weightLte, type: 'string', backendName: 'weight__lte' },
  { name: filterNames.weightGte, type: 'string', backendName: 'weight__gte' },
  { name: filterNames.unitCostGte, type: 'string', backendName: 'unit_cost__gte' },
  { name: filterNames.unitCostLte, type: 'string', backendName: 'unit_cost__lte' },
  { name: filterNames.category, type: 'string', backendName: 'category_id' },
  { name: filterNames.productStatus, type: 'string', backendName: 'status' },
  { name: filterNames.hasExportPrice, type: 'array', backendName: 'has_export_price' },
  { name: filterNames.exportPriceCountry, type: 'array', backendName: 'export_price_country' },
]

const viewIds = {
  default: 'default',
  withAlerts: 'withAlerts',
  withoutHsCode: 'withoutHsCode',
  withoutUnitCost: 'withoutUnitCost',
  withoutCountry: 'withoutCountry',
  withoutWeight: 'withoutWeight',
}

export const defaultViews = [
  {
    id: viewIds.default,
    name: 'Todos los productos',
    filters: {},
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.withAlerts,
    name: 'Con alertas pendientes',
    filters: {
      missing: 'any',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.withoutHsCode,
    name: 'Sin HS Code',
    filters: {
      missing: 'hs_code',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.withoutUnitCost,
    name: 'Sin coste unitario',
    filters: {
      missing: 'unit_cost',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.withoutCountry,
    name: 'Sin país',
    filters: {
      missing: 'country',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
  {
    id: viewIds.withoutWeight,
    name: 'Sin peso',
    filters: {
      missing: 'weight',
    },
    section: sectionIds.defaultViews,
    isDefaultView: true,
  },
]
